import { render, staticRenderFns } from "./agreement-list.vue?vue&type=template&id=639244ba&scoped=true&"
import script from "./agreement-list.vue?vue&type=script&lang=js&"
export * from "./agreement-list.vue?vue&type=script&lang=js&"
import style0 from "./agreement-list.vue?vue&type=style&index=0&id=639244ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639244ba",
  null
  
)

export default component.exports